module.exports = __webpack_public_path__ + "ai-bot-head-normalwp7737b2f13be8f8f5cd1d7e418bb92890.png";